import React from "react";
import { SEO, CustomerDetails, AdminLayout } from "../../../components";

const CustomerDetailsPage = () => {
  return (
    <>
      <SEO title="Customer Details" />
      <AdminLayout>
        <CustomerDetails />
      </AdminLayout>
    </>
  );
};

export default CustomerDetailsPage;
